/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================
* Time picker (hour, minute, second) using Flatpickr
=========================================================
*/

import PropTypes from "prop-types";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import SoftInput from "components/SoftInput";

function SoftTimePicker({ value, onChange, input = {}, ...rest }) {
  return (
    <Flatpickr
      {...rest}
      value={value || ""}
      onChange={onChange}
      options={{
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        dateFormat: "H:i:S",
        time_24hr: true,
      }}
      render={({ defaultValue }, ref) => (
        <SoftInput
          {...input}
          defaultValue={defaultValue}
          inputRef={ref}
          placeholder="HH:MM:SS"
        />
      )}
    />
  );
}

SoftTimePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.instanceOf(Date)]),
  onChange: PropTypes.func,
  input: PropTypes.objectOf(PropTypes.any),
};

export default SoftTimePicker;
